import React, { useEffect, useState } from "react";
import MainPageComponent from "./main.page";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function MainPageContainer() {
  const history = useHistory()
  const hasBranchViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Branch.LISTING_READ));
  const hasBranchAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Branch.LISTING_WRITE_CREATE));
  const isBranchOnly = useSelector(state => state.profile.nodeName.every(item => item.remarks === "branch"))
  const lang = useSelector(state => state.constant.languages)
  const isWithinLimit = useSelector(state =>
    (state.session.company.properties && state.session.company.properties.branch_count === null) ||
    (state.branch.activeCount && state.branch.activeCount < state.session.company.properties.branch_count)
  );

  useEffect(() => {
    if(!hasBranchViewAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasBranchViewAccessRight])

  const [activeIndex, setActiveIndex] = useState(0);

  if (!hasBranchViewAccessRight) return <LoadingComponent />;

  const tabLabels = [getLang(lang, "label.BRANCH_LIST")];

  const handleChange = (event, index) => {
    setActiveIndex(index);
  };

  return (
    <MainPageComponent
      hasBranchAddAccessRight={hasBranchAddAccessRight}
      handleChange={handleChange}
      activeIndex={activeIndex}
      tabLabels={tabLabels}
      isBranchOnly={isBranchOnly}
      lang={lang}
      isWithinLimit={isWithinLimit}
    />
  );
}

export default MainPageContainer;
